import { z } from 'zod';

export const DynamicBaseDTO = z.object({
    rule: z.object({
        key: z.string(),
        value: z.union([z.string(), z.array(z.string())]),
    }),
    displayRules: z.string().optional(),
});
